import React, { useState, useEffect } from 'react';
import { X, Heart, Briefcase, DollarSign, Globe } from 'lucide-react';
import '../styles/WelcomePopup.css';

const WelcomePopup = ({ language, translations, toggleLanguage }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if popup was shown recently
    const lastShown = localStorage.getItem('mobideal-welcome-popup');
    const now = new Date().getTime();
    const threeDays = 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds

    // Show popup if:
    // 1. Never shown before, OR
    // 2. Last shown more than 3 days ago
    if (!lastShown || (now - parseInt(lastShown)) > threeDays) {
      // Show popup after a short delay for better UX
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Store current timestamp
    localStorage.setItem('mobideal-welcome-popup', new Date().getTime().toString());
  };

  if (!isVisible) return null;

  const t = translations[language];

  return (
    <>
      <div className="welcome-popup-overlay" onClick={handleClose} />
      <div className="welcome-popup">
        <button className="welcome-popup-close" onClick={handleClose}>
          <X size={24} />
        </button>

        <button
          className="welcome-popup-language-toggle"
          onClick={toggleLanguage}
          title={language === 'EN' ? 'Passer au français' : 'Switch to English'}
        >
          <Globe size={18} />
          <span>{language}</span>
        </button>

        <div className="welcome-popup-header">
          <h2>{t.welcomeTitle}</h2>
        </div>

        <div className="welcome-popup-content">
          <div className="welcome-section">
            <p className="welcome-intro">{t.welcomeIntro}</p>
          </div>

          <div className="welcome-section">
            <h3>{t.welcomeFeaturesTitle}</h3>
            <ul className="welcome-features">
              <li>{t.welcomeFeature1}</li>
              <li>{t.welcomeFeature2}</li>
              <li>{t.welcomeFeature3}</li>
            </ul>
          </div>

          <div className="welcome-section welcome-donations">
            <div className="welcome-icon-header">
              <Heart className="welcome-icon" size={20} />
              <h3>{t.welcomeDonationsTitle}</h3>
            </div>
            <p>{t.welcomeDonationsText}</p>
            <div className="welcome-links">
              <a
                href="https://alzheimer.ca/en/take-action/donate"
                target="_blank"
                rel="noopener noreferrer"
                className="welcome-link"
              >
                {t.welcomeDonation1}
              </a>
              <a
                href="https://www.pancan.org/donate/"
                target="_blank"
                rel="noopener noreferrer"
                className="welcome-link"
              >
                {t.welcomeDonation2}
              </a>
            </div>
          </div>

          <div className="welcome-section welcome-linkedin">
            <div className="welcome-icon-header">
              <Briefcase className="welcome-icon" size={20} />
              <h3>{t.welcomeLinkedInTitle}</h3>
            </div>
            <p>{t.welcomeLinkedInText}</p>
            <a
              href="https://linkedin.com/in/simo-hakim"
              target="_blank"
              rel="noopener noreferrer"
              className="welcome-link linkedin-link"
            >
              LinkedIn
            </a>
          </div>

          <div className="welcome-section welcome-adblock">
            <div className="welcome-icon-header">
              <DollarSign className="welcome-icon" size={20} />
              <h3>{t.welcomeAdBlockTitle}</h3>
            </div>
            <p>{t.welcomeAdBlockText}</p>
          </div>
        </div>

        <div className="welcome-popup-footer">
          <button className="welcome-popup-button" onClick={handleClose}>
            {t.welcomeButtonClose}
          </button>
        </div>
      </div>
    </>
  );
};

export default WelcomePopup;
